const addressWithWizardContext = {
  type: 'AddressWithContext',
  props: {
    autoForward: true,
    inputProps: {
      postcode: {
        _label: 'Postcode',
        placeholder: '1234AB',
        maxLength: 6,
      },
      houseNumber: {
        _label: 'Huisnummer',
        placeholder: '123',
        type: 'tel',
      },
      addition: {
        _label: 'Toev.',
        placeholder: 'A',
        validator: [
          {
            fn: 'maxLength',
            args: ['De maximale lengte is 5 tekens.', 5],
          },
        ],
      },
    },
    fieldNames: {
      addition: '*.housenumberaddition',
      houseNumber: '*.housenumber',
      houseNumberWithAddition: '*.houseNumberWithAddition',
      postcode: '*.postcode',
      city: '*.city',
      street: '*.street',
      fullAddress: '*.fullAddress',
    },
  },
};

export default addressWithWizardContext;
